import CreatorBySlug from './CreatorBySlug';

export default CreatorBySlug;
